// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-filters {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  padding: 0 10px;
  background: white;
  border-bottom: 1px solid #d8d9ea;
  padding: 10px;
  margin-bottom: 20px;
}
li.nav-item {
  background: #5484ff;
  padding: 5px 25px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  border-radius: 50px;
  border: 0px;
  transition: 0.5s;
  box-shadow: 1px 2px 3px #494956;
  margin: 5px;
  outline: none !important;
}
li.nav-item:hover {
  background: #716f7a;
}
#pipestage {
  width: 20%;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/quick-filter/quick-filter.component.less"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAEA;EACI,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,+BAAA;EACA,WAAA;EACA,wBAAA;AAAJ;AACI;EACI,mBAAA;AACR;AAGA;EACI,UAAA;AADJ","sourcesContent":[".quick-filters{\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.2;\n    padding: 0 10px;\n    background: white;\n    border-bottom: 1px solid #d8d9ea;\n    padding: 10px;\n    margin-bottom: 20px;\n}\n\nli.nav-item{\n    background: #5484ff;\n    padding: 5px 25px;\n    color:white;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 50px;\n    border: 0px;\n    transition: 0.5s;\n    box-shadow: 1px 2px 3px #494956;\n    margin: 5px;\n    outline: none !important;\n    &:hover{\n        background: #716f7a;\n    }\n}\n\n#pipestage {\n    width: 20%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
